import { CompetitionTournamentInput as CompetitionTournamentInputComponent } from './CompetitionTournamentInput.component'
import { connector } from './CompetitionTournamentInput.connector';

export const CompetitionTournamentInput = connector(CompetitionTournamentInputComponent);
